const state = {
    excelFileToJsonData:{},
    dataUploadAddEditQuery: {}
};

const mutations = {
    EXCEL_FILE_TO_JSON_DATA(state,value){
        state.excelFileToJsonData = value;
    },
    DATA_UPLOAD_ADD_EDIT_QUERY(state,value){
        state.dataUploadAddEditQuery =  value;
    }
};

const actions = {

};

export default {
  state,
  mutations,
  actions
}